import { TEMPLATE_ICON } from "@/components/display/display-icon/artifacts";
import { useMatchRoute } from "@tanstack/react-router";
import { KitMenuTemplate, KitMenuTemplateProps } from "../KitMenuTemplate";
import { SETTINGS_GROUP_PARTIAL } from "./hooks";
import { KitTypeMenuProps } from "./types";

export const TemplateCreatorMenu: React.FC<KitTypeMenuProps> = ({
  mode,
  groupSlug,
  kit,
}) => {
  const matchRoute = useMatchRoute();
  const groups: KitMenuTemplateProps["groups"] = [
    {
      title: "Template",
      icon: TEMPLATE_ICON,
      active:
        !!matchRoute({
          to: "/w/$groupSlug/k/$kitUuid/template",
          params: { groupSlug, kitUuid: kit.uuid },
          fuzzy: true,
        }) &&
        !matchRoute({
          to: "/w/$groupSlug/k/$kitUuid/template-settings",
          params: { groupSlug, kitUuid: kit.uuid },
        }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/template" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
    {
      ...SETTINGS_GROUP_PARTIAL,
      active: !!matchRoute({
        to: "/w/$groupSlug/k/$kitUuid/template-settings",
        params: { groupSlug, kitUuid: kit.uuid },
        fuzzy: true,
      }),
      link: {
        to: "/w/$groupSlug/k/$kitUuid/template-settings" as const,
        params: { groupSlug, kitUuid: kit.uuid },
      },
    },
  ];
  return <KitMenuTemplate kit={kit} groups={groups} mode={mode} />;
};
